import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="main-footer mx-2">
        <strong className="float-left">
          Copyright © 2024{" "}
          <NavLink to="/terms"> {localStorage.getItem("organizationName")}</NavLink>.
        </strong>
        All rights reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 1.0.0
        </div>
      </footer>
    </>
  );
};

export default Footer;
